<div
    class="table-component"
    [ngClass]="{ fullscreen: isFullScreenMode, 'fit-columns-to-container': fitColumnsToContainer }"
>
    <ng-container>
        <ng-container *ngIf="showTableHeader">
            <fui-table-header
                #tableHeader
                [isLoading]="(isLoaded$ | async) === false"
                [ngClass]="{ headerHidden: isFullScreenMode }"
            >
                <ng-content fui-table-header-title select="[fui-table-header-title]"></ng-content>
                <ng-content table-header-right-block select="[table-header-right-block]"></ng-content>
            </fui-table-header>
        </ng-container>
        <ng-container *ngIf="isLoaded$ | async; else elseNonLoad">
            <div
                #tableContainer
                *ngIf="showTableContent$ | async"
                class="content content-sticky table-container-element h-full flex flex-col {{ classTable }}"
            >
                <div class="h-full flex flex-col gap-y-[12px]">
                    <div class="h-full" *ngIf="requestError">
                        <div class="table-panel">
                            <div class="buttons">
                                <ng-container [ngTemplateOutlet]="tableSettingsButton"></ng-container>
                            </div>
                        </div>
                        <div class="empty-table-content">
                            {{ appService.language_dictionary.table_settings_request_error }}
                        </div>
                    </div>
                    <ng-container *ngIf="(emptyResult$ | async) && !requestError && isEmptyFilter()">
                        <div class="empty-table-content">
                            <fui-empty-state
                                icon="table-search"
                                [text]="appService.language_dictionary.system_user_table_no_results"
                            ></fui-empty-state>
                        </div>
                    </ng-container>
                    <mat-card
                        #tableCard
                        class="h-full box-border table-card"
                        *ngIf="!requestError && !((emptyResult$ | async) && isEmptyFilter())"
                        [class.full-height]="isFullHeight$ | async"
                    >
                        <mat-card-content>
                            <div class="table-panel flex-none h-7 overflow-y-hidden px-2" #tablePanel>
                                <div class="buttons">
                                    <div class="table-action-buttons">
                                        <fui-button
                                            #filterButton
                                            (clickEvent)="openFilterPopup()"
                                            [title]="appService.language_dictionary.t_filter"
                                            [color]="isWorkingAction('userFilter') ? 'light' : 'flat'"
                                            [borderRadius]="'circle'"
                                            [label]="
                                                isWorkingAction('userFilter')
                                                    ? appService.language_dictionary.t_filter_active +
                                                      getCountProperty('userFilter')
                                                    : null
                                            "
                                            [type]="isWorkingAction('userFilter') ? 'button-long' : 'button-icon'"
                                            height="slim"
                                            icon="filter-outline"
                                            class="table-action-button"
                                        >
                                        </fui-button>
                                        <!-- Кнопка сброса -->
                                        <ng-container *ngIf="getCountProperty('userFilter', false) !== 0">
                                            <fui-button
                                                class="table-action-buttons-reset"
                                                (clickEvent)="filterEvent([])"
                                                [title]="appService.language_dictionary.system_reset"
                                                borderRadius="circle"
                                                type="button-icon"
                                                icon="close"
                                                color="neutral"
                                                height="slim"
                                            >
                                            </fui-button>
                                        </ng-container>
                                    </div>
                                    <!-- Группировка доступна в реестрах и таблицах с allowGrouping. -->
                                    <ng-container *ngIf="canGroupColumns">
                                        <div class="table-action-buttons">
                                            <fui-button
                                                #groupButton
                                                (clickEvent)="openGroupPopup()"
                                                [title]="appService.language_dictionary.t_group"
                                                [color]="isWorkingAction('userGroup') ? 'light' : 'flat'"
                                                [borderRadius]="'circle'"
                                                [label]="
                                                    isWorkingAction('userGroup')
                                                        ? appService.language_dictionary.t_group_active +
                                                          getCountProperty('userGroup')
                                                        : null
                                                "
                                                [type]="isWorkingAction('userGroup') ? 'button-long' : 'button-icon'"
                                                height="slim"
                                                icon="list-box-outline"
                                                class="table-action-button"
                                            >
                                            </fui-button>
                                            <!-- Кнопка сброса -->
                                            <ng-container *ngIf="getCountProperty('userGroup', false) !== 0">
                                                <fui-button
                                                    class="table-action-buttons-reset"
                                                    (clickEvent)="groupEvent([], true)"
                                                    [title]="appService.language_dictionary.system_reset"
                                                    borderRadius="circle"
                                                    type="button-icon"
                                                    icon="close"
                                                    color="neutral"
                                                    height="slim"
                                                >
                                                </fui-button>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <!-- Кнопка суммирования, пока не реализовано  -->
                                    <!--<fui-button-->
                                    <!--    #summarizeButton-->
                                    <!--    (clickEvent)="openPopupHeaderColumn({ actionType: actionColumn.summarize })"-->
                                    <!--    [title]="appService.language_dictionary.t_summarize"-->
                                    <!--    [color]="isWorkingAction('userSummarize') ? 'light' : 'flat'"-->
                                    <!--    [borderRadius]="isWorkingAction('userSummarize') ? 'rounded' : 'circle'"-->
                                    <!--    [label]="-->
                                    <!--        isWorkingAction('userSummarize')-->
                                    <!--            ? appService.language_dictionary.t_summarize_active +-->
                                    <!--              getCountProperty('userSummarize')-->
                                    <!--            : null-->
                                    <!--    "-->
                                    <!--    [type]="isWorkingAction('userSummarize') ? 'button-long' : 'button-icon'"-->
                                    <!--    height="slim"-->
                                    <!--    icon="sigma"-->
                                    <!-- >-->
                                    <!-- </fui-button>-->
                                    <div class="table-action-buttons">
                                        <fui-button
                                            #sortButton
                                            (clickEvent)="openSortPopup()"
                                            [title]="appService.language_dictionary.t_sort"
                                            [color]="'light'"
                                            [borderRadius]="'circle'"
                                            [label]="
                                                appService.language_dictionary.t_sort_active +
                                                getCountProperty('userSort')
                                            "
                                            [type]="'button-long'"
                                            height="slim"
                                            icon="sort"
                                            class="table-action-button"
                                        >
                                        </fui-button>
                                        <!-- Кнопка сброса -->
                                        <fui-button
                                            class="table-action-buttons-reset"
                                            (clickEvent)="resetSortColumns()"
                                            [title]="appService.language_dictionary.system_reset"
                                            borderRadius="circle"
                                            type="button-icon"
                                            icon="close"
                                            color="neutral"
                                            height="slim"
                                        >
                                        </fui-button>
                                    </div>
                                    <ng-container [ngTemplateOutlet]="tableSettingsButton"></ng-container>
                                    <ng-container *ngIf="isChangeTracking">
                                        <ng-template [ngTemplateOutlet]="changeForm"></ng-template>
                                    </ng-container>
                                </div>
                                <div class="paginator" *ngIf="!infiniteScroll">
                                    <custom-paginator
                                        table-header
                                        #UsersMatPaginatorTop
                                        (page)="pageEvent = onPaginateChange($event)"
                                        [length]="lengthTables"
                                        [pageIndex]="settingsTable.userIndex"
                                        [pageSize]="settingsTable.userSize"
                                        [pageSizeOptions]="pageSizeOptionsTables"
                                    >
                                    </custom-paginator>
                                </div>
                            </div>

                            <div
                                [class.full-height-scroll-wrapper]="isFullHeight$ | async"
                                class="mat-table-wrapper"
                                #matTable
                            >
                                <div
                                    class="mat-table-container mat-table-container-table"
                                    [class.full-height-scroll]="isFullHeight$ | async"
                                    [class.!hidden]="!loadSettings"
                                >
                                    <mat-table
                                        #dataMatTable="matTable"
                                        [dataSource]="dataTables.filteredData"
                                        [trackBy]="trackByColumn ? rowTrackBy : undefined"
                                    >
                                        <ng-container matColumnDef="select" sticky>
                                            <mat-header-cell *matHeaderCellDef class="header-cell-select">
                                                <div>
                                                    <div [class.hidden]="selection.hasValue()" class="number">№</div>
                                                    <div [class.hidden]="!selection.hasValue()" class="master-toggle">
                                                        <mat-checkbox
                                                            (change)="$event ? masterToggle() : null"
                                                            [fuiTooltip]="
                                                                appService.language_dictionary.check_all_table_row
                                                            "
                                                            [checked]="selection.hasValue() && isAllSelected()"
                                                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                                                            [aria-label]="checkboxLabel()"
                                                        >
                                                        </mat-checkbox>
                                                    </div>
                                                </div>
                                            </mat-header-cell>
                                            <!-- Ячейка номера строки / чекбокс выбора  -->
                                            <mat-cell
                                                *matCellDef="let row; let rowIndex = index"
                                                class="cell-select"
                                                [ngClass]="{ 'group-cell': row.type === 'group' }"
                                            >
                                                <ng-container *ngIf="rowNumbers[rowIndex] as rowNumber">
                                                    <mat-checkbox
                                                        (click)="$event.stopPropagation()"
                                                        (dblclick)="$event.stopPropagation()"
                                                        (change)="$event ? selection.toggle(row) : null"
                                                        [checked]="selection.isSelected(row)"
                                                        [aria-label]="checkboxLabel(row)"
                                                    >
                                                    </mat-checkbox>
                                                    <div class="number">
                                                        {{ rowNumber }}
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="row.type === 'group'">
                                                    <div
                                                        class="group-title"
                                                        [style.padding-left]="(row.level - 1) * 40 + 'px'"
                                                    >
                                                        <fui-icon
                                                            [size]="1"
                                                            [icon]="!!row.expanded ? 'chevron-down' : 'chevron-up'"
                                                        ></fui-icon>
                                                        <app-switcher-cell
                                                            [column]="getColumnGroupInfo(row)"
                                                            [row]="row"
                                                        ></app-switcher-cell>
                                                        <span>&nbsp;({{ row.count }})</span>
                                                    </div>
                                                </ng-container>
                                            </mat-cell>
                                        </ng-container>
                                        <!-- Палитры в таблице -->
                                        <ng-container *ngIf="dataPalette && dataPalette.length">
                                            <ng-container *ngFor="let columnPalette of dataPalette">
                                                <!-- Если простая палитра -->
                                                <ng-container *ngIf="!columnPalette.merged">
                                                    <ng-container
                                                        [matColumnDef]="'system_color_' + columnPalette.index"
                                                        [sticky]="
                                                            (showMenuColumnPalette$ | async)?.[columnPalette.title]
                                                                ?.is_sticky ?? false
                                                        "
                                                    >
                                                        <mat-header-cell *matHeaderCellDef class="header-cell-palette">
                                                            <ng-container>
                                                                <!-- Заголовок колонки хедера  -->
                                                                <app-table-column-header-menu
                                                                    class="w-full h-full group"
                                                                    [isTableRegistry]="canGroupColumns"
                                                                    [columnData]="
                                                                        (showMenuColumnPalette$ | async)?.[
                                                                            columnPalette.title
                                                                        ]
                                                                    "
                                                                    [columnPalette]="columnPalette"
                                                                    (filterRun)="openFilterPopup($event)"
                                                                    (sortRun)="modifySortColumn($event)"
                                                                    (groupRun)="groupEvent($event)"
                                                                    (hideRun)="handleHideColumn($event)"
                                                                    (pinToggleRun)="handlePinToggle($event)"
                                                                    (groupCustomAction)="groupCustomAction($event)"
                                                                >
                                                                </app-table-column-header-menu>
                                                            </ng-container>
                                                        </mat-header-cell>
                                                        <ng-container *matCellDef="let row">
                                                            <mat-cell
                                                                style="width: 44px"
                                                                class="text-center"
                                                                [ngClass]="{ 'group-cell': row.type === 'group' }"
                                                            >
                                                                <ng-container
                                                                    *ngIf="row['color_' + columnPalette.index]"
                                                                >
                                                                    <span
                                                                        class="table-color-element"
                                                                        [style.backgroundColor]="
                                                                            row['color_' + columnPalette.index]
                                                                        "
                                                                    ></span>
                                                                </ng-container>
                                                            </mat-cell>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                                <!-- Если сложная палитра -->
                                                <ng-container *ngIf="columnPalette.merged">
                                                    <ng-container
                                                        [matColumnDef]="'system_color_' + columnPalette.index"
                                                    >
                                                        <mat-header-cell *matHeaderCellDef class="header-cell-palette">
                                                            <div>
                                                                <mat-icon
                                                                    class="table-color-history"
                                                                    [fuiTooltip]="
                                                                        appService.language_dictionary.palette_legend
                                                                    "
                                                                    #menuColorHistoryTrigger="matMenuTrigger"
                                                                    [matMenuTriggerFor]="menuColorHistory"
                                                                    fontSet="mdi"
                                                                    [fontIcon]="'mdi-' + columnPalette.icon"
                                                                ></mat-icon>
                                                                <mat-menu #menuColorHistory="matMenu">
                                                                    <div
                                                                        class="relative"
                                                                        (click)="$event.stopPropagation()"
                                                                    >
                                                                        <app-palette-legend
                                                                            [palette]="columnPalette"
                                                                        ></app-palette-legend>
                                                                        <div class="absolute -top-1 right-1">
                                                                            <fui-button
                                                                                type="button-icon"
                                                                                height="slim"
                                                                                borderRadius="circle"
                                                                                color="color"
                                                                                icon="close"
                                                                                (clickEvent)="
                                                                                    menuColorHistoryTrigger.closeMenu()
                                                                                "
                                                                                title="{{
                                                                                    appService.language_dictionary
                                                                                        .system_close
                                                                                }}"
                                                                            ></fui-button>
                                                                        </div>
                                                                    </div>
                                                                </mat-menu>
                                                            </div>
                                                        </mat-header-cell>
                                                        <ng-container
                                                            *ngFor="let mergedPalette of columnPalette.merged_data"
                                                        >
                                                            <ng-container *ngIf="!mergedPalette.main">
                                                                <mat-cell
                                                                    *matCellDef="let row"
                                                                    style="width: 44px"
                                                                    class="text-center"
                                                                    [ngClass]="{ 'group-cell': row.type === 'group' }"
                                                                >
                                                                    <ng-container
                                                                        *ngIf="row['color_' + mergedPalette.index]"
                                                                    >
                                                                        <span
                                                                            class="table-color-element"
                                                                            [style.backgroundColor]="
                                                                                row['color_' + mergedPalette.index]
                                                                            "
                                                                        ></span>
                                                                    </ng-container>
                                                                </mat-cell>
                                                            </ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                        <!-- Пользовательские колонки в таблице  -->
                                        <ng-container
                                            *ngFor="
                                                let column of getDisplayedUserColumn();
                                                let i = index;
                                                trackBy: trackByUserColumnsName
                                            "
                                            [matColumnDef]="column.name"
                                            [sticky]="column.is_sticky"
                                        >
                                            <mat-header-cell
                                                class="mat-table-column-class"
                                                *matHeaderCellDef
                                                mwlResizable
                                                resizeColumn
                                                [enableGhostResize]="true"
                                                [targetColumn]="column"
                                                [style.width.px]="column.width"
                                            >
                                                <!-- Заголовок колонки хедера  -->
                                                <app-table-column-header-menu
                                                    class="w-full h-full group"
                                                    [isTableRegistry]="canGroupColumns"
                                                    [columnData]="getDataColumnByMenu(column)"
                                                    (filterRun)="openFilterPopup($event)"
                                                    (sortRun)="modifySortColumn($event)"
                                                    (groupRun)="groupEvent($event)"
                                                    (hideRun)="handleHideColumn($event)"
                                                    (pinToggleRun)="handlePinToggle($event)"
                                                    (groupCustomAction)="groupCustomAction($event)"
                                                ></app-table-column-header-menu>
                                                <div
                                                    *ngIf="!fitColumnsToContainer"
                                                    class="resize-handle-right"
                                                    mwlResizeHandle
                                                    [resizeEdges]="{ right: true }"
                                                ></div>
                                            </mat-header-cell>
                                            <ng-container *matCellDef="let row">
                                                <mat-cell
                                                    class="mat-table-column-class"
                                                    [fuiTooltip]="
                                                        row.type !== 'group'
                                                            ? (getCellTooltip(column, row)
                                                              | formater: column.type : '' : column?.transformParam
                                                              | stripHtml)
                                                            : ''
                                                    "
                                                    (click)="
                                                        groupByTreeColumns?.isTree &&
                                                        groupByTreeColumns?.columnGroup === column.name
                                                            ? groupHeaderTreeClick($event, row)
                                                            : null
                                                    "
                                                    [class.color-row]="!!row[mainPalette]"
                                                    [style.background-color]="row[mainPalette]"
                                                    [style.width.px]="column.width"
                                                    [style.border-bottom-color]="
                                                        !!row[mainPalette] ? '#ffffff' : 'rgba(0, 0, 0, .12)'
                                                    "
                                                    [style.text-align]="getAlign(column)"
                                                    [style.z-index]="0"
                                                    [ngClass]="{ 'group-cell': row.type === 'group' }"
                                                >
                                                    <div
                                                        *ngIf="row.type !== 'group'"
                                                        class="cell-content"
                                                        [style.-webkit-line-clamp]="settingsTable.cell_rows"
                                                        [style]="{
                                                            'padding-right': column.type === 'float' ? '0.5em' : null,
                                                            display:
                                                                groupByTreeColumns?.columnGroup === column.name
                                                                    ? 'flex'
                                                                    : null,
                                                        }"
                                                        [ngClass]="{ 'group-cell__content': row.type === 'group' }"
                                                    >
                                                        <ng-container
                                                            *ngIf="
                                                                settingsEditFields?.isEdit &&
                                                                (!settingsEditFields.excludeField ||
                                                                    (settingsEditFields.excludeField &&
                                                                        !row[settingsEditFields.excludeField])) &&
                                                                settingsEditFields?.fields[column.name] &&
                                                                formEdit.get(column.name + '_' + row.id)
                                                            "
                                                        >
                                                            <ng-container
                                                                dynamic-field
                                                                [field]="{
                                                                    type: settingsEditFields?.fields[column.name].type,
                                                                    label: '',
                                                                    mask: settingsEditFields?.fields[column.name].mask
                                                                        ? settingsEditFields?.fields[column.name].mask
                                                                        : null,
                                                                    name: 'value',
                                                                    validations: [],
                                                                }"
                                                                [group]="formEdit.get(column.name + '_' + row.id)"
                                                            >
                                                            </ng-container>
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="
                                                                !settingsEditFields?.isEdit ||
                                                                (settingsEditFields?.isEdit &&
                                                                    (!settingsEditFields?.fields[column.name] ||
                                                                        (settingsEditFields.excludeField &&
                                                                            row[settingsEditFields.excludeField])))
                                                            "
                                                        >
                                                            <!-- Для орг. структуры или если в таблице есть группировка -->
                                                            <!-- Добавляем кнопку сворачивания элементов -->
                                                            <ng-container
                                                                *ngIf="
                                                                    groupByTreeColumns?.isTree &&
                                                                    groupByTreeColumns?.columnGroup === column.name
                                                                "
                                                            >
                                                                <div
                                                                    [ngClass]="{ 'group-title': isGroup }"
                                                                    [style]="
                                                                        groupByTreeColumns?.columnGroup === column.name
                                                                            ? 'display: flex'
                                                                            : null
                                                                    "
                                                                >
                                                                    <ng-container *ngIf="row.level > 1">
                                                                        <ng-container
                                                                            *ngFor="
                                                                                let i of [].constructor(row.level - 1)
                                                                            "
                                                                        >
                                                                            <span class="table-tree-indentation"
                                                                                >&nbsp;</span
                                                                            >
                                                                        </ng-container>
                                                                    </ng-container>
                                                                    <fui-icon
                                                                        *ngIf="row?.is_children"
                                                                        [size]="1"
                                                                        [icon]="
                                                                            row?.expanded
                                                                                ? 'chevron-down'
                                                                                : 'chevron-up'
                                                                        "
                                                                    ></fui-icon>
                                                                    <span
                                                                        *ngIf="!row?.is_children"
                                                                        class="table-tree-indentation"
                                                                        >&nbsp;</span
                                                                    >
                                                                </div>
                                                            </ng-container>

                                                            <!--  Вставляем контент в ячейку в зависимости от типа-->
                                                            <ng-container *ngIf="row.type !== 'group'">
                                                                <app-switcher-cell
                                                                    [column]="column"
                                                                    [row]="row"
                                                                ></app-switcher-cell>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </mat-cell>
                                            </ng-container>
                                        </ng-container>
                                        <mat-header-row *matHeaderRowDef="getDisplayedColumn(); sticky: true">
                                        </mat-header-row>
                                        <mat-row
                                            [id]="'row-' + index"
                                            [class.mat-row-selected]="selection.isSelected(row)"
                                            *matRowDef="let row; columns: getDisplayedColumn(); let index = index"
                                            (click)="handleRowClick($event, row)"
                                            (dblclick)="handleDblClick($event, row)"
                                            (contextmenu)="onRightClick($event, row)"
                                        ></mat-row>
                                    </mat-table>
                                    <ng-container
                                        *ngIf="infiniteScroll && isLoadingMore"
                                        [ngTemplateOutlet]="elseNonLoad"
                                    ></ng-container>
                                    <fui-empty-state
                                        *ngIf="(emptyResult$ | async) && !requestError"
                                        icon="table-search"
                                        [text]="appService.language_dictionary.system_user_table_no_results_found"
                                    ></fui-empty-state>
                                </div>
                                <div class="table-block-load" [class.!hidden]="loadSettings"></div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <ngx-spinner [name]="spinnerName" [fullScreen]="false" bdColor="transparent" [template]="spinnerHtml">
            </ngx-spinner>
        </ng-container>
        <ng-template #elseNonLoad>
            <div class="skeleton-container px-2" role="status">
                <span class="sr-only">{{ appService.language_dictionary.system_loading }}</span>
                <div class="w-full mb-2" aria-hidden="true">
                    <div class="skeleton w-full h-8"></div>
                </div>
                <div class="w-full flex justify-between gap-2" aria-hidden="true">
                    <div *ngFor="let _ of [].constructor(6)" class="w-full h-6 skeleton"></div>
                </div>
            </div>
        </ng-template>
    </ng-container>
</div>
<fui-sidebar
    [visible]="showHistorySidebar$ | async"
    [title]="appService.language_dictionary.factor_history_of_changes"
    matSideNavCss="bg-surface w-1/2"
    (openedChange)="showHistorySidebar$.next($event)"
>
    <ng-container *ngIf="(showHistorySidebar$ | async) && (historySidebarData$ | async) as historyData">
        <ng-container
            *ngComponentOutlet="historySidebarComponent$ | async; inputs: { data: historyData }"
        ></ng-container>
    </ng-container>
</fui-sidebar>
<ng-template #changeForm let-field="field">
    <fui-button
        (clickEvent)="showRevisionHistory(item)"
        [icon]="'clock-outline'"
        [title]="appService.language_dictionary.factor_show_revision_history"
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'gray'"
        [height]="'slim'"
    >
    </fui-button>
</ng-template>
<!-- Кнопка настроек таблицы -->
<ng-template #tableSettingsButton>
    <ng-container *ngIf="!tableService?.hideTableSettings">
        <fui-button
            (clickEvent)="openSettingsDialog()"
            title="{{ appService.language_dictionary.system_user_table_settings }}"
            borderRadius="circle"
            type="button-icon"
            height="slim"
            icon="tune"
            color="flat"
        >
        </fui-button>
    </ng-container>
</ng-template>

<app-table-column-action
    #tableColumnAction
    [actionType]="columnActionType"
    [userColumns]="settingsTable.userColumns"
    [userGroup]="settingsTable.userGroup"
    [startValuesForm]="valuesFormColumnActions"
    [statusTooltip]="(columnActionTooltip | async) ?? null"
    (filterRun)="filterEvent($event)"
    (sortRun)="setSortColumns($event)"
    (sortReset)="resetSortColumns()"
    (groupRun)="groupEvent($event, true)"
    (groupCustomAction)="groupCustomAction($event)"
></app-table-column-action>
